/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import ThreeDotsLoader from '../../Components/LoadingDots';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

export default function ListDistributors({
    list,
    handleActivateOrDeactivate,
    OpenPopup,
    setOpenPopup,
    actvloader,
    setactvloader,
    isEditId,
    setisEditId,
    viewprevilegeassigned,
    updateprevilegeassigned,
}) {
    const [selectedId, setselectedId] = useState('');
    const [selectedDis, setSelectedDis] = useState([]);
    const ref = useRef();

    const handleActionButtonStatus = () => {
        setselectedId('');
    };

    return (
        <AnimatePresence>
            <tbody>
                <Modal
                    style={customStyles}
                    isOpen={OpenPopup !== ''}
                    ariaHideApp={false}
                    onClick={() => {
                        setOpenPopup('');
                        setactvloader(false);
                    }}
                    onRequestClose={() => setOpenPopup('')}
                >
                    <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                        <div
                            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                        >
                            <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                                {OpenPopup === 'active' ? (
                                    <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                        {selectedDis.STATUS === 'A' ? 'Deactivate' : 'Activate'}
                                        {' '}
                                        {' '}
                                        Distributor
                                    </h5>
                                ) : (
                                    null
                                )}
                                <button
                                    type="button"
                                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            {OpenPopup === 'active' ? (
                                <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                    <p className="text-xs6 font-normal text-[#555259]">
                                        {`${selectedDis.PARTY_NAME}`}
                                        {' '}
                                        is currently
                                        {' '}
                                        {selectedDis.STATUS === 'A' ? 'Active' : 'Inactive'}
                                        . Are you sure you
                                        {' '}
                                        want to
                                        {' '}
                                        {selectedDis.STATUS === 'A' ? 'Deactivate' : 'Activate'}
                                        ?
                                    </p>
                                </div>
                            ) : (
                                null
                            )}
                            <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-6 rounded-b-md">
                                <button
                                    onClick={() => {
                                        setOpenPopup('');
                                        setactvloader(false);
                                    }}
                                    type="button"
                                    className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleActivateOrDeactivate(selectedDis.FALCON_LOGIN_STATUS === 'A' ? 'I' : 'A', selectedDis.ACCOUNT_NUMBER)}
                                >
                                    {actvloader ? <ThreeDotsLoader /> : 'Yes'}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                {list.map((item, index) => (
                    <motion.tr
                        className="bg-[#FDFDFE] border-b border-[#DFEAF7] relative"
                        style={{ zIndex: `${50 - index}` }}
                        animate={{ opacity: 1, x: 0 }}
                        initial={{ opacity: 0, x: -10 }}
                        exit={{ opacity: 0, x: -10 }}
                        transition={{ duration: 0.15 }}
                        key={item.ACCOUNT_NUMBER}
                    >
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                            {item.ACCOUNT_NUMBER}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                            {item.ATTRIBUTE1}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                            {item.FIRST_NAME ? item.FIRST_NAME : '-'}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                            {item.LAST_NAME ? item.LAST_NAME : '-'}

                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                            {item.PARTY_NAME.length > 27 ? `${item.PARTY_NAME.substring(0, 28)}...` : item.PARTY_NAME}

                        </td>
                        <td className="text-xs font-normal py-2.5 px-7 text-center">
                            <a
                                href="#"
                                className={`flex rounded-sm border-2 ${item.STATUS === 'A' ? 'border-[#D7F8DC] bg-[#D7F8DC]' : 'border-[#808285] bg-[#808285] text-[#FFFFFF]'} py-0.5 pr-1.5 cursor-default px-1 w-[82px]`}
                            >
                                <img src={`images/${item.STATUS === 'A' ? 'Active-icon.svg' : 'inactive-1.svg'}`} alt="icon" className="px-2" />
                                {item.STATUS === 'A' ? 'Active' : 'Inactive'}
                            </a>
                        </td>
                        <td className="text-xs font-normal py-2.5 px-7 text-center">
                            <a
                                href="#"
                                className={`flex rounded-sm border-2 ${item.FALCON_LOGIN_STATUS === 'A' ? 'border-[#D7F8DC] bg-[#D7F8DC]' : 'border-[#808285] bg-[#808285] text-[#FFFFFF]'} py-0.5 pr-1.5 cursor-default px-1 w-[82px]`}
                            >
                                <img src={`images/${item.FALCON_LOGIN_STATUS === 'A' ? 'Active-icon.svg' : 'inactive-1.svg'}`} alt="icon" className="px-2" />
                                {item.FALCON_LOGIN_STATUS === 'A' ? 'Active' : 'Inactive'}
                            </a>
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                            {item.EMAIL_ADDRESS}
                        </td>
                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                            {item.PRIMARY_PHONE_NUMBER === null ? '-' : item.PRIMARY_PHONE_NUMBER}
                        </td>
                        <td className="py-2.5 px-7">
                            <div
                                className="dropdown relative flex justify-center cursor-pointer"
                                onClick={() => {
                                    if (selectedId === '') {
                                        setselectedId(item.ACCOUNT_NUMBER);
                                    } else {
                                        setselectedId('');
                                    }
                                }}
                            >
                                <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img
                                        src="images/more-vertical.svg"
                                        alt="icon"
                                    />
                                </button>
                                <ul className={`dropdown-menu absolute ${selectedId === item.ACCOUNT_NUMBER ? 'show' : 'hidden'} z-[${index + 50}] bg-[#FFFFFF] rounded-lg min-w-[123px] shadow-s2 px-4`} aria-labelledby="dropdownMenuButton1" style={{ right: '50px', top: '0px' }}>
                                    {viewprevilegeassigned
                                    && (
                                        <li className="pt-1.5 pb-1.5" style={{ borderBottom: '#E2E2E2' }}>
                                            <Link to={`/distributors/${item.ACCOUNT_NUMBER}/view`} className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block">View</Link>
                                        </li>
                                    )}
                                    <span className="border-b-yellow-800" />
                                    {updateprevilegeassigned
                                    && (
                                        <li className="pt-1.5 pb-1.5">
                                            <Link to={`/distributors/${item.ACCOUNT_NUMBER}/update`} className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block">Edit</Link>
                                        </li>
                                    )}
                                    {updateprevilegeassigned
                                    && (
                                        <li
                                            className="pt-1.5 pb-1.5"
                                            data-bs-toggle="modal"
                                            data-bs-target="#deactivateUserModal"
                                            onClick={() => {
                                                setSelectedDis(item);
                                                setOpenPopup('active');
                                            }}
                                            ref={ref}
                                        >
                                            <a
                                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"
                                                href="javascript:void(0)"
                                            >
                                                {item.FALCON_LOGIN_STATUS === 'A' ? 'Deactivate' : 'Activate'}

                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </td>
                    </motion.tr>
                ))}
                <div className={['filter-overlay ', (selectedId !== '') ? 'filter-open' : ''].join('')} onClick={() => handleActionButtonStatus()} />
            </tbody>
        </AnimatePresence>
    );
}
